/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Sync_In_ProgressInputs */

const en_history_sync_in_progress = /** @type {(inputs: History_Sync_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {History_Sync_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const history_sync_in_progress = /** @type {((inputs?: History_Sync_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Sync_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_history_sync_in_progress(inputs)
});